import { ICONS } from '../../../common/constants'
import useAuth from '../../../common/hooks/useAuth'
import useData from '../../../common/hooks/useData'
import ResourceList from '../../../components/admin/ResourceList'
import MessageSection from '../../../components/common/MessageSection'
import Spinner from '../../../components/common/Spinner'
import Tag from '../../../components/common/Tag'
import PremiumBanner from '../../admin/app-billing/PremiumBanner'

export default function ContactFormsList({ enablePullToRefresh }) {
    const auth = useAuth()

    const { hasForms, hasFormsLoading, hasFormsError } = useData(
        '/v1/users/me/has-forms',
        'hasForms',
        (data) => data?.hasForms,
    )

    if (hasFormsLoading) {
        return <Spinner />
    }

    if (hasFormsError) {
        return (
            <MessageSection type="alert">
                {`Unexpected error, please contact Support.`}
            </MessageSection>
        )
    }

    // Without access, users can still see forms shared with them
    const canCreate = auth.user.isPremiumUser || hasForms || auth.isAdmin

    return (
        <>
            {!canCreate && (
                <section>
                    <PremiumBanner />
                </section>
            )}
            <ResourceList
                enablePullToRefresh={enablePullToRefresh}
                emptyText={
                    canCreate
                        ? 'Create a new contact form to embed to your website.'
                        : 'No contact forms shared with you.'
                }
                renderMainButton
                itemClickPath={`/contact-forms/:item.id`}
                newItemLabel={'New form'}
                initialQuery={{ source: 'contact' }}
                apiUrl={'/v1/contact-forms'}
                getItemsFromResponse={(data) => data?.results}
                newItemPath={canCreate ? '/contact-forms/new' : null}
                paginated
                paginationLimit={20}
                fields={[
                    {
                        column: 1,
                        getValue: (item) => item.title || item.id,
                        getClassName: () => 'title',
                    },
                    {
                        column: 1,
                        getValue: (item) => item.whitelistedDomains.join(', '),
                        getClassName: () => 'subtitle',
                    },
                    {
                        column: 1,
                        getValue: (item) =>
                            item.isShared ? <Tag outline>Shared</Tag> : '',
                    },
                ]}
                actions={[
                    {
                        title: 'Permissions (Beta)',
                        link: '/settings/permissions/form/:item.id',
                        icon: ICONS.LOCK_GRAY,
                        getHide: (item) => item.isShared,
                    },
                ]}
            />
        </>
    )
}
